import { GetterTree } from 'vuex'

import { RootState } from '../../types'
import { ViewState } from './types'

export const getters: GetterTree<ViewState, RootState> = {
}
